<template>
	<div id="merchant" class='gcardfr' style="margin: -0px;background: none;" v-loading='loading'>
		<el-row :gutter="20" class=''>
			<el-col :span='8'>
				<el-button size='small' type="primary" @click='addTer'>{{ $t('merchant.add_branch') }}</el-button>
				<el-button size='small' @click="batchDel" :disabled="sRows.length == 0" type='danger' plain>{{ $t('app_mulDel') }}
				</el-button>
			</el-col>
			<el-col :offset="$isAdminType()?8:16" :span='8'>
				<div class="glineflex">
					<label class="glinelb">{{ $t('merchant.branch_name') }}：</label>
					<el-input size='small' v-model='srcEquip' @keyup.enter.native="indexget" placeholder=""></el-input>
				</div>
			</el-col>
		</el-row>
		<el-table ref="multipleTable" class='gtbtop' tooltip-effect="dark" @row-click='rowClick' :data="tableData"
			@selection-change="batchSelected" style="width: 100%">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="branchName" :label="$t('merchant.branch_name')" width="">
			</el-table-column>
			<el-table-column prop="branchNo" :label="$t('merchant.branch_number')" width="">
			</el-table-column>
			<el-table-column prop="createTime" :label="$t('app_add_time')" :formatter="setTime" width="170">
			</el-table-column>
			<el-table-column :label="$t('app_operation')" width="100">
				<template slot-scope="scope">
					<!-- <el-button type='text' @click='editRow(scope.row)'>编辑</el-button>    
          <label class='opbline'>|</label> -->
					<el-button @click='delRow(scope.row.id)' type='text' class='opdcolor'>{{ $t('app_delete') }}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<Pages class='gpages' :cpage='page' :ctotal="total" :config='pconfig'></Pages>

		<el-dialog @close="closeDia" class='gstdia' :title="editObj? $t('merchant.edit_branch') : $t('merchant.add_branch')" :visible.sync="showDia">
			<el-form :model="tform" :rules="rules" ref="ruleForm">
				<el-form-item :label="$t('merchant.branch_name')" :label-width="$formlbWidth" prop='name'>
					<el-input v-model="tform.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('merchant.branch_number')" :label-width="$formlbWidth" prop='no'>
					<el-input v-model="tform.no" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeDia">{{ $t("app_cancel") }}</el-button>
					<el-button type="primary" @click="beforeRqs">{{ $t("app_sure") }}</el-button>
				</el-form-item>
			</el-form>
			<!-- <div slot="footer" class="dialog-footer">        
      </div> -->
		</el-dialog>
		<EquipList :show='showEquDia' :config='econfig'></EquipList>
	</div>
</template>

<style>
	.eqbs-ball-green {
		width: 6px;
		height: 6px;
		display: inline-block;
		border-radius: 6px;
		overflow: hidden;
		background: rgba(82, 196, 26, 1);
	}

	.eqbs-ball-gray {
		width: 6px;
		height: 6px;
		display: inline-block;
		border-radius: 6px;
		overflow: hidden;
		background: rgba(191, 191, 191, 1);
	}
</style>

<script>
	import Pages from '@/components/Pages.vue'
	import Merchant from '@/components/MerchIP.vue'
	import EquipList from '@/components/EquipList.vue'
	import dayjs from 'dayjs'
	export default {
		data() {
			return {
				mcid: '',
				editObj: '',
				isEdit: false,
				sortMc: {},
				editMc: {},
				srcEquip: '',
				agentId: '',
				pconfig: '',
				tableData: [],
				showDia: false,
				tform: {
					name: '',
					no: '',
				},
				page: 1,
				total: 0,
				loading: false,
				sRows: [],
				config: '',
				econfig: {},
				showEquDia: false,
				merchantId: '',
				rules: {
					name: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					no: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					pno: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					parent: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}]
				}
			}
		},
		components: {
			Pages,
			Merchant,
			EquipList
		},
		methods: {
			setTime(obj) {
				var time = dayjs(obj.createTime)
				return time.format('YYYY-MM-DD HH:mm:ss')
			},
			indexget() {
				this.page = 1
				this.getList()
			},
			rowClick(row, column) {
				return
				if (column.label != this.$t('app_operation')) {
					this.toDetail(row)
				}
			},
			bindRqs(id, did) {
				if (did.length != 0) {
					this.$bcstoreBindEq(id, did, res => {
						if (res.status == 200) {
							this.getList()
							this.showEquDia = false
							this.$message.success(res.message)
						} else {
							this.$message.error(res.message)
						}
					}, '')
				} else {
					this.showEquDia = false
				}
			},
			batchDel() {
				this.$showMsgBox(this.$t('app_delete_question_2'), () => {
					var arr = []
					this.sRows.forEach(item => {
						arr.push(item.id)
					})
					this.delRqs(arr.toString())
				}, '')
			},
			delRqs(id) {
				this.loading = true
				this.$delBcstore(id, res => {
					this.loading = false
					if (res.status == 200) {
						this.getList()
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = false
				})
			},
			delRow(id) {
				this.$showMsgBox(this.$t('app_delete_question'), () => {
					this.delRqs(id)
				}, '')
			},
			addTer() {
				this.showDia = true
				this.setMcCtr('')
			},
			toDetail(row) {
				this.$router.push({
					path: '/bcstore/detail',
					query: {
						deviceid: '',
						id: row.id
					}
				})
			},
			editRow(row) {
				this.editObj = row
				this.showDia = true
				this.tform.name = row.branchName
				this.tform.no = row.branchNo
			},
			bindEquip(row) {
				var _this = this
				this.showEquDia = true
				this.merchantId = row.merchantId
				this.econfig = {
					mcid: row.merchantId,
					agid: row.agentId,
					type: 0,
					title: this.$t('merchant.merchant_equ'),
					callback: ids => {
						_this.bindRqs(row.id, ids)
					}
				}
			},
			getList() {
				this.loading = true
				var merchantNo = this.$route.query.merchantId
				var branchName = this.srcEquip
				this.$bcstoreList(this.page, this.$gRow, merchantNo, branchName, res => {
					this.loading = false
					if (res.status == 200) {
						this.total = res.total
						this.tableData = res.data
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			batchSelected(val) {
				this.sRows = val
			},
			closeDia() {
				this.showDia = false
				this.tform.name = '',
					this.tform.no = '',
					this.editObj = ''
			},
			beforeRqs() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.okDia()
					}
				})
			},
			okDia() {
				this.loading = true
				var form = this.tform
				if (this.editObj) {
					this.$editBcstore(this.editObj.id, form.name, form.no, this.mcid, res => {
						this.loading = false
						if (res.status == 200) {
							this.closeDia()
							this.getList()
						} else {
							this.$message.error(res.message)
						}
					}, '')
				} else {
					this.$addBcstore(form.name, form.no, this.mcid, res => {
						this.loading = false
						if (res.status == 200) {
							this.closeDia()
							this.getList()
						} else {
							this.$message.error(res.message)
						}
					}, '')
				}
			},
			setMcCtr(vl) {
				var _this = this
				this.editMc = {
					size: '',
					value: vl ? vl : '',
					callback: (vl) => {
						_this.tform.parent = vl
						if (vl)
							this.$mcGetmcno(vl, res => {
								if (res.data[0]) {
									_this.tform.pno = res.data[0].merchantNo
								}
							}, '')
					}
				}
			}
		},
		mounted() {
			var _this = this
			this.mcid = this.$route.query.merchantId
			this.pconfig = {
				callback: page => {
					///
					_this.page = page
					_this.getList()
				}
			}
			this.getList()
			this.sortMc = {
				size: 'small',
				value: '',
				callback: (vl) => {
					this.agentId = vl
					this.indexget()
				}
			}
		}
	}
</script>
